<template>
  <v-container class="video-container pa-0 ma-0" fluid>
    <v-row class="fin-box-shadow pa-0 ma-0" id="fixedOW"
           align="center">
      <v-col cols="12" class="pa-0 ma-0"
             style="text-align: center;">
        <fin-video-secure :max-height="maxHeight"
                          :width="videoPlayerWidth"
                          style="margin: auto"
                          :isApp="isApp">
          <iframe width="100%"
                  height="100%"
                  :src="src"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen></iframe>
        </fin-video-secure>

      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import finBrowser from "@/js/finBrowser"

export default {
  name: "fin-video-player",
  props: {
    /*TODO why no property width, optional detection to object*/
    videoPlayerWidthForBreakpoints: {
      type: Object
    },
    src: {
      type: String
    },
    maxHeight: {
      type: String,
      default: '80vh'
    }
  },
  computed: {
    isApp() {
      return finBrowser.IS_IOS_OR_ANDROID_APP
    },
    videoPlayerWidth() {
      if (this.videoPlayerWidthForBreakpoints) {
        return this.$valueByBreakpoint(this.videoPlayerWidthForBreakpoints)
      }
      else {
        return 560
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
